import './crmCustomerAccountEnhancement';

// Adds Select All / Clear All controls to VinCentrix document-selection checkbox groups.
// Legal consent / acknowledgement checkboxes are intentionally excluded.
const SELECTOR = '.vc-pp-modal,.vc-sr-modal,.vc-esign-modal,.vc-signature-modal,[data-vc-esign]';

const styles = `
.vc-select-all-row{display:flex;justify-content:flex-end;align-items:center;gap:8px;margin:8px 0 6px}.vc-select-all-row button{border:1px solid rgba(96,165,250,.24);background:rgba(59,130,246,.08);color:#dbeafe;border-radius:8px;padding:7px 10px;font-size:10px;font-weight:900;cursor:pointer}.vc-select-all-row button:hover{background:rgba(59,130,246,.16)}
@media(max-width:700px){.vc-select-all-row{justify-content:stretch}.vc-select-all-row button{flex:1;padding:10px}}
`;
const addStyles=()=>{if(document.getElementById('vc-select-all-styles'))return;const s=document.createElement('style');s.id='vc-select-all-styles';s.textContent=styles;document.head.appendChild(s)};

const eligible = root => [...root.querySelectorAll('input[type="checkbox"]')].filter(cb => {
  if(cb.disabled) return false;
  const key = `${cb.name||''} ${cb.id||''} ${cb.getAttribute('aria-label')||''} ${cb.closest('label')?.innerText||''}`.toLowerCase();
  return !/(consent|acknowledg|agree|terms|electronic records|legal)/.test(key) && !cb.hasAttribute('data-no-select-all');
});

const enhanceRoot = root => {
  if(root.dataset.vcSelectAllEnhanced==='1') return;
  const boxes=eligible(root); if(boxes.length<2) return;
  root.dataset.vcSelectAllEnhanced='1';
  const row=document.createElement('div');row.className='vc-select-all-row';
  const all=document.createElement('button');all.type='button';all.textContent='Select All';
  const clear=document.createElement('button');clear.type='button';clear.textContent='Clear All';
  const fire=cb=>{cb.dispatchEvent(new Event('input',{bubbles:true}));cb.dispatchEvent(new Event('change',{bubbles:true}))};
  all.onclick=()=>boxes.forEach(cb=>{if(!cb.checked){cb.checked=true;fire(cb)}});
  clear.onclick=()=>boxes.forEach(cb=>{if(cb.checked){cb.checked=false;fire(cb)}});
  row.append(all,clear);
  const first=boxes[0]; const anchor=first.closest('fieldset,.vc-checkbox-group,.vc-pp-doc-list,.vc-esign-doc-list')||first.parentElement;
  if(anchor?.parentElement) anchor.parentElement.insertBefore(row,anchor); else root.prepend(row);
};
const enhance=()=>document.querySelectorAll(SELECTOR).forEach(enhanceRoot);
addStyles();
new MutationObserver(enhance).observe(document.documentElement,{childList:true,subtree:true});
setTimeout(enhance,800);
export {};
